import script from "./ComprobantesContables.vue?vue&type=script&setup=true&lang=js"
export * from "./ComprobantesContables.vue?vue&type=script&setup=true&lang=js"

import "./ComprobantesContables.vue?vue&type=style&index=0&id=19c5438e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c5438e"]])

export default __exports__